import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import RecordedStreamTest from './recordedStreamTest';
import LiveStreamTest from './liveStreamTest';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <Box role="tabpanel" hidden={value !== index}>
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AutoTest() {
  const [value, setValue] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      setValue(0);
    }, 200);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Live" {...a11yProps(0)} />
          <Tab label="Recorded" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <LiveStreamTest />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <RecordedStreamTest />
      </TabPanel>
    </Box>
  );
}
